export const Chartoptions = {
  lineHeightAnnotation: {
    always: true,
    hover: false,
    lineweight: 1.5,
  },
  animation: {
    duration: 2000,
  },

  maintainAspectRatio: false,

  responsive: true,
  scales: {
    xAxes: [
      {
        type: "time",
        distribution: "linear",
      },
    ],
  },
};
